import React from 'react';
import type {IntlShape} from 'react-intl';

import {ModalDialog} from '../../modal-dialog';
import {ChannelNameInput} from '../../../molecules/channel-name-input';

import {Hints} from './hints';
import {useTexts} from './hooks';
import styles from './styles.module.css';

export type Props = {
    userNames: string[];
    siteUrl: string;
    displayNameError?: string;
    urlShortenLength: number;
    channelNameLimit: number;
    onClose: () => void;
    onConfirm: () => void;
    path: string;
    url: string;
    onUrlChange: (url: string) => void;
    urlError?: string;
    showUrlError?: boolean;
    errorAlert?: React.ReactNode;
    serverError?: string;
    displayName: string;
    onDisplayNameChange: (displayName: string) => void;
    intl: IntlShape;
};

export const ConvertGroupToChannelModal = (props: Props) => {
    const {description, title, confirmText, cancelText, label, urlLabel, doneBtnText, editBtnText} = useTexts(
        props.intl,
        props.userNames,
    );
    const confirmEnabled = props.displayName && !props.displayNameError &&
        props.url && !props.urlError && !props.serverError && !props.errorAlert;
    const onEnterKeyPressed = () => {
        if (confirmEnabled) {
            props.onConfirm();
        }
    };

    return (
        <ModalDialog
            isOpen={true}
            title={title}
            confirmText={confirmText}
            cancelText={cancelText}
            isConfirmDisabled={!confirmEnabled}
            error={props.serverError}
            onEnterKeyPressed={onEnterKeyPressed}
            onConfirm={props.onConfirm}
            onClose={props.onClose}
            autoFocusCancelBtn={false}
            nodeRef={{} as React.MutableRefObject<HTMLElement>}
        >
            <p className={styles.description}>{description}</p>
            <Hints intl={props.intl} />
            <ChannelNameInput
                label={label}
                displayName={props.displayName}
                displayNameError={props.displayNameError}
                onDisplayNameChange={props.onDisplayNameChange}
                url={props.url}
                urlError={props.urlError}
                showUrlError={props.showUrlError}
                urlLabel={urlLabel}
                onUrlChange={props.onUrlChange}
                baseUrl={props.siteUrl}
                path={props.path}
                urlShortenLength={props.urlShortenLength}
                limit={props.channelNameLimit}
                doneButtonMessage={doneBtnText}
                editButtonMessage={editBtnText}
            />
            {props.errorAlert}
        </ModalDialog>
    );
};
